import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-platformsetup',
  templateUrl: './platformsetup.component.html',
  styleUrls: ['./platformsetup.component.sass']
})
export class PlatformsetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
